import type { ReactNode } from "react";
import { FileText, Settings2 } from "lucide-react";
import { StepInfoRow } from "../StepInfoRow";
import { getString, getNumber, getBool } from "./helpers";
import type { SummaryTranslator } from "./types";

export function getLoadSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const mode = getString(config.mode) || "append";
  const autoCreateTable = getBool(config.autoCreateTable);
  const primaryKeys = Array.isArray(config.primaryKeys) ? (config.primaryKeys as string[]) : [];
  const batchSize = getNumber(config.batchSize);

  items.push(
    <StepInfoRow
      key="mode"
      icon={<Settings2 className="size-3.5" />}
      label={t("summaries.load.label_mode")}
      value={
        <span className="flex items-center gap-2">
          <span className="rounded bg-blue-100 px-1.5 py-0.5 text-[10px] font-medium text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
            {mode.toUpperCase()}
          </span>
          {autoCreateTable && (
            <span className="text-[10px] text-green-600 dark:text-green-400">{t("summaries.load.auto_create")}</span>
          )}
        </span>
      }
    />
  );

  if (primaryKeys.length > 0) {
    items.push(
      <StepInfoRow key="pk" icon={<FileText className="size-3.5" />} label={t("summaries.load.label_primary_keys")} value={primaryKeys.join(", ")} mono />
    );
  }

  if (batchSize) {
    items.push(
      <StepInfoRow key="batch" icon={<Settings2 className="size-3.5" />} label={t("summaries.load.label_batch")} value={t("summaries.load.batch_rows", { count: batchSize.toLocaleString() })} />
    );
  }

  return items;
}
